import { useTranslation } from "@localization/useTranslation.ts";
import { InformationSecurityProperty } from "../../../incidentLog/IncidentLogDialog.types.ts";
import { getInformationSecurityPropertySelectOptions } from "../../../incidentLog/incidentLogDialog/CreateEditIncidentLogDialog.hooks.ts";
import { IncidentLogAffectedSecurityPropertiesFieldProps } from "./IncidentLogAffectedSecurityPropertiesField.tsx";

export function useIncidentLogAffectedSecurityPropertiesField(props: IncidentLogAffectedSecurityPropertiesFieldProps) {
    const { translateString } = useTranslation();

    return {
        options: getInformationSecurityPropertySelectOptions(translateString),
        chosenOptions: props.affectedSecurityProperties.map((property) => property.toString()),
        onChange: (ids: Array<string>) => props.onChange(ids.map((id) => Number(id) as InformationSecurityProperty)),
    };
}
